import { DIMixins, DIValidators, EFeatureFlags } from "@/core/@types/types";
import { IF360FeatureFlagValidator } from "@/core/validators/F360FeatureFlagValidator";
import { IUsuarioAdminValidator } from "@/core/validators/usuarioAdmin/IUsuarioAdminValidator";
import { IAntecipaPermissionValidator } from "./IAntecipaPermissionValidator";
import { diContainer } from "@/di";
import type { IUserProfileStorageMixin } from "@/core/plugins/storage/UserProfileStorageMixin";
import { inject, injectable } from "inversify";

@injectable()
export default class AntecipaPermissionValidator
  implements IAntecipaPermissionValidator
{
  @inject(DIMixins.USER_PROFILE_STORAGE)
  userProfileMixin!: IUserProfileStorageMixin;

  podeAcessar(): boolean | null {
    const featureAntecipa = diContainer
      .get<IF360FeatureFlagValidator>(DIValidators.FEATURE_FLAGS)
      .handleValidationByName(EFeatureFlags.telaAntecipa);
    const isAdm = diContainer
      .get<IUsuarioAdminValidator>(DIValidators.USUARIO_ADMIN)
      .handle();

    if (featureAntecipa && isAdm) return true;

    return false;
  }

  podeAntecipar(): boolean | null {
    if (!this.podeAcessar()) return false;
    const storage = this.userProfileMixin.handleGetUserProfile();

    const isRepresentanteLegal = storage?.IsRepresentanteLegal;

    if (!isRepresentanteLegal) return false;

    return true;
  }
}
